import styled from '@emotion/styled';
import { BreadcrumbsV2 } from '@zola/zola-ui/src/components/BreadcrumbsV2';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import { COLORS3, FONT, SPACING } from '@zola/zola-ui/src/styles/emotion';
import MEDIA_QUERY_V2 from '@zola/zola-ui/src/styles/emotion/mediaQueryV2';
import H from '@zola/zola-ui/src/typography/Headings';
import P from '@zola/zola-ui/src/typography/Paragraphs';

export const StyledBreadcrumbs = styled(BreadcrumbsV2)`
  margin: ${SPACING.S16} 0 0 ${SPACING.S24};
  ${MEDIA_QUERY_V2.EXCLUDE_MOBILE} {
    margin-left: ${SPACING.LG};
  }
  ${MEDIA_QUERY_V2.DESKTOP_MASSIVE} {
    margin-left: 0;
    margin-top: 0;
    padding-top: ${SPACING.S16};
    padding-left: ${SPACING.S24};
  }
`;

export const StyledH1 = styled(H.TitleAccent1)`
  margin-bottom: ${SPACING.S8};
  ${MEDIA_QUERY_V2.MOBILE} {
    padding: 0 ${SPACING.S24};
  }
`;
export const Dek = styled(P.BodyBase)`
  margin-bottom: ${SPACING.S24};
  ${MEDIA_QUERY_V2.MOBILE} {
    padding: 0 ${SPACING.S24};
  }
`;

export const HeaderWrapper = styled.div<{ noBreadcrumbs: boolean; showBottomBorder?: boolean }>`
  text-align: center;
  padding: ${props => (props.noBreadcrumbs ? `${SPACING.LG} 0 ` : '0')};
  border-bottom: ${props => (props.showBottomBorder ? `1px solid ${COLORS3.BLACK_030} ` : 'none')};
`;

export const DestinationsWrapper = styled.div`
  display: grid;
  row-gap: ${SPACING.SM};
  justify-content: flex-start;
  margin: 0 ${SPACING.S24};

  ${MEDIA_QUERY_V2.MOBILE} {
    grid-template-columns: repeat(auto-fit, 25%);
  }

  ${MEDIA_QUERY_V2.MOBILE_XS} {
    grid-template-columns: repeat(auto-fit, 33.33%);
  }

  ${MEDIA_QUERY_V2.TABLET} {
    grid-template-columns: repeat(auto-fit, 20%);
  }

  ${MEDIA_QUERY_V2.DESKTOP} {
    grid-template-columns: repeat(auto-fit, 16.66%);
  }
  ${MEDIA_QUERY_V2.DESKTOP_LG} {
    grid-template-columns: repeat(auto-fit, 12.5%);
  }

  ${MEDIA_QUERY_V2.EXCLUDE_MOBILE} {
    justify-content: center;
  }
`;

export const DestinationImage = styled.img`
  border-radius: 100%;
`;

export const DestinationLink = styled(LinkV2)`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.S8};
  text-decoration: none;
  transition: scale 0.2s ease-in-out;

  margin: 0 ${SPACING.S8};
  ${MEDIA_QUERY_V2.EXCLUDE_MOBILE} {
    gap: ${SPACING.S16};
    margin: 0 ${SPACING.SM};
  }
  &:hover {
    scale: 1.1;
  }
`;

export const DestinationName = styled(P.BodyBase)`
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
`;
